import classnames from "classnames";
import * as React from "react";

import { Card, CardContent, WithStyles } from "@material-ui/core";
import { StyleRules, Theme, withStyles } from "@material-ui/core/styles";
import { SvgIconProps } from "@material-ui/core/SvgIcon";
import { promo, Text } from "..";

type ClassNames = "card" | "selected" | "content" | "icon" | "discount";

const styles = (theme: Theme): StyleRules<ClassNames> => ({
    card: {
        borderRadius: 5,
        cursor: "pointer",
        marginTop: theme.spacing.unit * 2,
        "&:not(:first-child)": {
            marginLeft: theme.spacing.unit
        }
    },
    content: {
        display: "flex",
        flexDirection: "column",
        justifyContent: "space-between",
        alignItems: "center"
    },
    icon: {
        fontSize: 50
    },
    selected: {
        backgroundColor: "#333333",
        color: "white"
    },
    discount: {
        textDecoration: "line-through",
        fontWeight: 300
    }
});

export const formatPrice = (price: number): string => (price / 100) % 1 === 0 ? `${price / 100}` : `${price / 100}0`;

export interface License {
    id: string,
    title: string,
    label: string,
    discount: number,
    price: number,
    icon: React.ComponentType<SvgIconProps>
}

interface LicenseProps {
    license: License,
    selected: boolean,
    onClick: () => void
}

class LicenseComp extends React.Component<WithStyles<ClassNames> & LicenseProps> {
    //
    public render() {
        const {classes, license, onClick, selected} = this.props;
        const {title, price, discount, label, icon: Icon} = license;
        return (
            <Card className={classnames(classes.card, { [classes.selected]: selected })} {...{onClick}}>
                <CardContent className={classes.content}>
                    <Text variant="title4" color="inherit">{title}</Text>
                    <Icon className={classes.icon} color="inherit" />
                    <Text variant="footnote" color="inherit" align="center">
                        {label}
                    </Text>
                    <Text color="inherit" align="center">
                        {promo.active && <span className={classes.discount}>${formatPrice(price)}</span>}
                        {promo.active && <br />}
                        ${formatPrice(promo.active ? discount : price)}
                    </Text>
                </CardContent>
            </Card>
        );
    }
}

export default withStyles(styles)<LicenseProps>(LicenseComp);



// WEBPACK FOOTER //
// ./src/components/checkout/License.tsx